import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../styles/themeColors';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  drawer: {
    height: `calc(100vh - ${stylesConstants.headerHeight}px)`,
    width: stylesConstants.sideMenuWidth,
    boxShadow: `2px 2px 5px ${themeColors.borders}`,
    backgroundColor: themeColors.secondary,
  },
  group: {
    backgroundColor: themeColors.secondary,
    borderBottom: stylesConstants.defaultBorder,
  },
  iconColor: {
    color: themeColors.inactive,
  },
}));
